/* De Kleurenwaaier — de zoeklade.
 *
 * The header's search controls are still ordinary links to /search. This file
 * upgrades them: it intercepts the click, opens the band, and fetches
 * sections/kw-suggest.liquid over the Section Rendering API as the visitor
 * types. Nothing here is required for search to work — with the script absent
 * or broken the links go to the search page exactly as they did before, which
 * is why they were left as anchors rather than turned into buttons.
 *
 * ON MARKING THE TERM. Shopify matches on titles and descriptions, so a search
 * for a note returns products whose printed notes are the reason for the match.
 * Marking the term inside the name and the note line is what turns a list of
 * products into an answer. It is done over text nodes, never with innerHTML on
 * a string built from user input.
 */

(function () {
  var wrap = document.querySelector('[data-kw-seek]');
  if (!wrap) return;

  var form = wrap.querySelector('[data-kw-seek-form]');
  var field = wrap.querySelector('[data-kw-seek-field]');
  var panel = wrap.querySelector('[data-kw-seek-panel]');
  var live = wrap.querySelector('[data-kw-seek-live]');
  var closer = wrap.querySelector('[data-kw-seek-close]');
  var toggles = document.querySelectorAll('[data-kw-seek-toggle]');
  if (!form || !field || !panel) return;

  var SECTION = wrap.getAttribute('data-kw-section') || 'kw-suggest';
  var MIN = 2;
  var WAIT = 180;

  var open = false;
  var timer = null;
  var shut = null;
  var ctrl = null;
  var cache = {};
  var opts = [];
  var idx = -1;

  /* --- opening and closing --------------------------------------------- */

  function setOpen(v) {
    if (v === open) return;
    open = v;

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].setAttribute('aria-expanded', v ? 'true' : 'false');
    }
    field.setAttribute('aria-expanded', v ? 'true' : 'false');

    window.clearTimeout(shut);

    if (v) {
      /* A menu and a search drawer would sit on top of each other. */
      var menus = document.querySelectorAll('.kw-head-bar details[open]');
      for (var m = 0; m < menus.length; m++) menus[m].open = false;

      wrap.hidden = false;
      try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
      try { field.setSelectionRange(field.value.length, field.value.length); } catch (e) {}
      if (field.value.trim().length >= MIN) ask(field.value);
    } else {
      clear();
      shut = window.setTimeout(function () {
        if (!open) wrap.hidden = true;
      }, 200);
    }
  }

  function clear() {
    window.clearTimeout(timer);
    if (ctrl) { ctrl.abort(); ctrl = null; }
    panel.innerHTML = '';
    wrap.classList.remove('has-panel');
    opts = [];
    idx = -1;
    field.removeAttribute('aria-activedescendant');
  }

  /* --- fetching -------------------------------------------------------- */

  function ask(raw) {
    var term = raw.trim();
    if (term.length < MIN) { clear(); return; }

    if (cache[term] !== undefined) { paint(cache[term], term); return; }

    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController === 'function' ? new AbortController() : null;

    var url = '/search?q=' + encodeURIComponent(term) +
      '&type=product&section_id=' + encodeURIComponent(SECTION);

    fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        cache[term] = html;
        if (field.value.trim() === term) paint(html, term);
      })
      .catch(function () { /* an aborted keystroke is the normal case */ });
  }

  function paint(html, term) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('[data-kw-seek-in]');
    panel.innerHTML = '';
    if (!inner) { wrap.classList.remove('has-panel'); return; }

    panel.appendChild(document.importNode(inner, true));
    mark(panel, term);

    opts = [].slice.call(panel.querySelectorAll('[role="option"]'));
    for (var i = 0; i < opts.length; i++) opts[i].id = 'kw-seek-o-' + i;
    idx = -1;
    field.removeAttribute('aria-activedescendant');

    wrap.classList.add('has-panel');

    if (live) {
      var n = parseInt(inner.getAttribute('data-kw-count') || '0', 10);
      live.textContent = n === 0
        ? 'Geen resultaten voor ' + term
        : n + (n === 1 ? ' resultaat' : ' resultaten') + ' voor ' + term;
    }
  }

  /* --- marking --------------------------------------------------------- */

  function esc(w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function mark(scope, term) {
    var words = term.split(/\s+/).filter(function (w) { return w.length >= MIN; }).map(esc);
    if (!words.length) return;
    var re = new RegExp('(' + words.join('|') + ')', 'gi');

    var fields = scope.querySelectorAll('[data-kw-mark]');
    for (var f = 0; f < fields.length; f++) {
      var walker = document.createTreeWalker(fields[f], NodeFilter.SHOW_TEXT, null, false);
      var nodes = [], node;
      while ((node = walker.nextNode())) nodes.push(node);

      for (var n = 0; n < nodes.length; n++) {
        var text = nodes[n].nodeValue;
        if (!re.test(text)) { re.lastIndex = 0; continue; }
        re.lastIndex = 0;

        var frag = document.createDocumentFragment();
        var at = 0, m;
        while ((m = re.exec(text))) {
          if (m.index > at) frag.appendChild(document.createTextNode(text.slice(at, m.index)));
          var hit = document.createElement('mark');
          hit.className = 'kw-seek__hit';
          hit.appendChild(document.createTextNode(m[0]));
          frag.appendChild(hit);
          at = m.index + m[0].length;
        }
        if (at < text.length) frag.appendChild(document.createTextNode(text.slice(at)));
        nodes[n].parentNode.replaceChild(frag, nodes[n]);
      }
    }
  }

  /* --- keyboard -------------------------------------------------------- */

  function select(i) {
    if (idx > -1 && opts[idx]) {
      opts[idx].classList.remove('is-on');
      opts[idx].setAttribute('aria-selected', 'false');
    }
    idx = i;
    if (idx > -1 && opts[idx]) {
      opts[idx].classList.add('is-on');
      opts[idx].setAttribute('aria-selected', 'true');
      opts[idx].scrollIntoView({ block: 'nearest' });
      field.setAttribute('aria-activedescendant', opts[idx].id);
    } else {
      field.removeAttribute('aria-activedescendant');
    }
  }

  function move(step) {
    if (!opts.length) return;
    var next = idx + step;
    if (next < -1) next = opts.length - 1;
    if (next >= opts.length) next = -1;
    select(next);
  }

  /* --- wiring ---------------------------------------------------------- */

  for (var t = 0; t < toggles.length; t++) {
    toggles[t].addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!open);
    });
  }

  if (closer) closer.addEventListener('click', function () {
    field.value = '';
    setOpen(false);
    if (toggles.length) toggles[0].focus();
  });

  field.addEventListener('input', function () {
    var v = field.value;
    window.clearTimeout(timer);
    if (v.trim().length < MIN) { clear(); return; }
    timer = window.setTimeout(function () { ask(v); }, WAIT);
  });

  field.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
    else if (e.key === 'Escape') {
      e.preventDefault();
      if (idx > -1) { select(-1); return; }
      field.value = '';
      setOpen(false);
      if (toggles.length) toggles[0].focus();
    } else if (e.key === 'Enter' && idx > -1 && opts[idx]) {
      e.preventDefault();
      window.location.assign(opts[idx].href);
    }
  });

  form.addEventListener('submit', function (e) {
    if (field.value.trim().length === 0) e.preventDefault();
  });

  /* A row is only highlighted by the pointer while the pointer is the thing
     choosing; otherwise hover and the keyboard selection fight each other. */
  panel.addEventListener('pointermove', function () {
    if (idx > -1) select(-1);
  }, { passive: true });

  document.addEventListener('pointerdown', function (e) {
    if (!open) return;
    if (wrap.contains(e.target)) return;
    if (e.target.closest && e.target.closest('[data-kw-seek-toggle]')) return;
    setOpen(false);
  });
})();
